export default class UploadValidator {
  static TEST_SUCCESS = 'Success';
  static TEST_FAIL = 'Failed';
  static FAIL_MESSAGE = {
    INVALID_COMPANY: 'Cell X has invalid company.',
    INVALID_NUMBER: 'Cell X data type is not valid as number.',
    MISSING_METRICS: 'Column C has wrong or missing metrics.',
    INVALID_DATE: 'Cell X has invalid date format.',
    INVALID_FYYEARS: 'Row 10 has wrong or missing time periods',
    CELL_EMPTY: 'Cell X on should not be blank.',
    START_DATE_EMPTY: 'The start date should not be blank on cell X.',
    END_DATE_EMPTY: 'The end date should not be blank on cell X.',
  };
  static METRIC_RULES = [
    'Cash',
    'EBIT',
    'EBITA',
    'EPS',
    'General and Administrative',
    'Gross Profit',
    'Gross Margin',
    'Net Income',
    'R&D Expense',
    'Total Revenue',
    'Sales Growth YoY',
    'Sales and Marketing',
    'Total Debt',
    'Operating Expense',
    'Start Date',
    'End Date',
  ];
  constructor(workSheet, companyInfo) {
    this.companyInfo = companyInfo;
    // const range = 'B52:W84';
    const titleColumn = 13;
    const startColumn = 14;
    const dateStartColumn = 43;
    const endColumn = 46;
    const startColumnLetter = 'B';
    const endColumnLetter = 'W';
    const valueStartColumnLetter = 'D';
    const metricsColumn = 'C';
    const blankRow = 42;
    const companyAStart = startColumn;
    const companyAEnd = 27;
    const companyBStart = 28;
    const companyBEnd = 41;
    this.company = [];
    this.values = [];
    this.fyYears = [];
    this.metrics = [];
    this.dates = [];
    this.requiredDate = [];
    this.shouldCompanyNameRevert = workSheet.B14?.v !== workSheet.B43?.v;
    console.log('this.shouldCompanyNameRevert: ', this.shouldCompanyNameRevert);
    console.log('workSheet.B14: ', workSheet.B14?.v);
    console.log('workSheet.B43: ', workSheet.B43?.v);
    for (const i in workSheet) {
      const columnLetter = i.slice(0, 1);
      const columnNumber = parseInt(i.slice(1));
      console.log(workSheet, i, columnLetter, columnNumber);
      // company
      if (
        columnLetter === startColumnLetter &&
        columnNumber >= startColumn &&
        columnNumber <= endColumn &&
        columnNumber !== blankRow
      ) {
        this.company.push({
          cell: i,
          value: workSheet[i].v,
          ...workSheet[i],
        });
      }
      // all numbers need to be checked
      if (
        valueStartColumnLetter.charCodeAt() <= columnLetter.charCodeAt() &&
        columnLetter.charCodeAt() <= endColumnLetter.charCodeAt() &&
        columnNumber >= startColumn &&
        columnNumber <= endColumn - 5 &&
        columnNumber !== blankRow
      ) {
        this.values.push({
          cell: i,
          value: workSheet[i].v,
        });
      }
      // all fyYears
      if (
        valueStartColumnLetter.charCodeAt() <= columnLetter.charCodeAt() &&
        columnLetter.charCodeAt() <= endColumnLetter.charCodeAt() &&
        columnNumber === titleColumn &&
        columnNumber !== blankRow
      ) {
        this.fyYears.push({
          cell: i,
          value: workSheet[i].v,
        });
      }
      if (
        valueStartColumnLetter.charCodeAt() <= columnLetter.charCodeAt() &&
        columnLetter.charCodeAt() <= endColumnLetter.charCodeAt() &&
        columnNumber >= startColumn &&
        columnNumber < blankRow &&
        workSheet[i].t !== 'e' && // value 'e' indicate cell error
        workSheet[i].v
        // !this.requiredDate.some((cell) => cell.startsWith(columnLetter))
      ) {
        const companyADate = [`${columnLetter}43`, `${columnLetter}44`];
        const companyBDate = [`${columnLetter}45`, `${columnLetter}46`];
        if (columnNumber >= companyAStart && columnNumber <= companyAEnd) {
          this.requiredDate = this.requiredDate.concat(
            !this.shouldCompanyNameRevert ? companyADate : companyBDate,
          );
        }
        if (columnNumber >= companyBStart && columnNumber <= companyBEnd) {
          this.requiredDate = this.requiredDate.concat(
            !this.shouldCompanyNameRevert ? companyBDate : companyADate,
          );
        }
      }
      // all metrics
      if (
        metricsColumn.charCodeAt() === columnLetter.charCodeAt() &&
        columnNumber >= startColumn &&
        columnNumber <= endColumn &&
        columnNumber !== blankRow
      ) {
        this.metrics.push({
          cell: i,
          value: workSheet[i].v,
        });
      }
      // all dates
      if (
        valueStartColumnLetter.charCodeAt() <= columnLetter.charCodeAt() &&
        endColumnLetter.charCodeAt() >= columnLetter.charCodeAt() &&
        columnNumber >= dateStartColumn &&
        columnNumber <= endColumn &&
        columnNumber !== blankRow
      ) {
        this.dates.push({
          cell: i,
          value: workSheet[i].v,
        });
      }
    }
    console.log('this.company: ', this.company);
    // console.log(this);
    // this.workSheet.
  }
  getUniqueValue(arr) {
    return Array.from(new Set(arr.map((c) => c.value)));
  }
  handleMessage(msgObj) {
    const result = [];
    if (msgObj.type === 'metrics') {
      return [this.constructor.FAIL_MESSAGE.MISSING_METRICS];
    }
    if (msgObj.type === 'fyyears') {
      return [this.constructor.FAIL_MESSAGE.INVALID_FYYEARS];
    }
    msgObj.where.forEach((cell) => {
      switch (msgObj.type) {
        case 'company':
        case 'number':
        case 'date':
          result.push(msgObj.message.replace('X', cell.cell));
          break;
        default:
      }
    });
    return result;
  }
  testCompany() {
    // console.log(this.company);
    return new Promise((resolve, reject) => {
      // const companys = this.getUniqueValue(this.company);
      const result = this.company.filter(
        (c) => !this.companyInfo.includes(c.value),
      );
      if (result.length <= 0) {
        resolve(this.constructor.TEST_SUCCESS);
      } else {
        resolve(
          this.handleMessage({
            type: 'company',
            message: this.constructor.FAIL_MESSAGE.INVALID_COMPANY,
            where: result,
          }),
        );
      }
    });
  }
  // 测试用户要填的值
  testCells() {
    return new Promise((resolve, reject) => {
      const result = this.values.filter(
        (obj) => typeof obj.value !== 'number' && obj.value !== '',
      );
      if (result.length < 1) {
        resolve(this.constructor.TEST_SUCCESS);
      } else {
        resolve(
          this.handleMessage({
            type: 'number',
            message: this.constructor.FAIL_MESSAGE.INVALID_NUMBER,
            where: result,
          }),
        );
      }
    });
  }
  testMetric() {
    return new Promise((resolve, reject) => {
      const metrics = this.getUniqueValue(this.metrics);
      let wrongResult = [];
      let missingResult = false;
      // const nullMetrics = this.metrics.filter((m) => m.value === '');
      if (this.metrics.length !== this.constructor.METRIC_RULES.length * 2) {
        missingResult = true;
      }
      wrongResult = this.constructor.METRIC_RULES.filter((rule) => {
        if (!metrics.includes(rule)) {
          return rule;
        }
        return null;
      });
      if (wrongResult.length !== 0 || missingResult) {
        resolve(
          this.handleMessage({
            type: 'metrics',
            message: this.constructor.FAIL_MESSAGE.MISSING_METRICS,
            // where: result,
          }),
        );
      } else {
        resolve(this.constructor.TEST_SUCCESS);
      }
    });
  }
  testDate() {
    // console.
    return new Promise((resolve, reject) => {
      const result = this.dates.filter(
        (date) => typeof date.value !== 'object' && date.value !== '',
      );
      if (result.length > 0) {
        resolve(
          this.handleMessage({
            type: 'date',
            message: this.constructor.FAIL_MESSAGE.INVALID_DATE,
            where: result,
          }),
        );
      } else {
        resolve(this.constructor.TEST_SUCCESS);
      }
    });
  }
  testFyYears() {
    const result = {
      type: 'fyyears',
      message: this.constructor.FAIL_MESSAGE.INVALID_DATE,
    };
    const tempObj = this.fyYears.filter((f) => {
      const arr = f.value.split(',');
      if (arr[1] && arr[1].length !== 5) {
        return f;
      }
      if (
        arr[0] === 'FY' ||
        arr[0] === 'Q1' ||
        arr[0] === 'Q2' ||
        arr[0] === 'Q3' ||
        arr[0] === 'Q4'
      ) {
        return null;
      }
      return f;
    });
    return new Promise((resolve, reject) => {
      if (this.fyYears.length < 20 || tempObj.length > 0) {
        resolve(this.handleMessage(result));
      } else {
        resolve(this.constructor.TEST_SUCCESS);
      }
    });
  }
  testDateEmpty() {
    // start date and end date are required if correspond FY/Q1/Q2/Q3 column has metric data
    // skip Q4 column
    const Q4CellLetters = this.fyYears
      .filter((i) => i?.value?.startsWith('Q4'))
      .map((i) => i.cell[0]);
    const requiredDateUniq = Array.from(new Set(this.requiredDate));
    const emptyDates = requiredDateUniq
      .filter(
        (cell) =>
          !Q4CellLetters.includes(cell[0]) &&
          !this.dates.find((i) => i.cell === cell)?.value,
      )
      .map((cell) => ({ cell }));
    const valid = emptyDates.length === 0;
    const startDates = emptyDates.filter(
      (i) => i.cell.includes('43') || i.cell.includes('45'),
    );
    const endDates = emptyDates.filter(
      (i) => i.cell.includes('44') || i.cell.includes('46'),
    );

    return Promise.resolve(
      valid
        ? this.constructor.TEST_SUCCESS
        : [
            ...this.handleMessage({
              type: 'date',
              message: this.constructor.FAIL_MESSAGE.START_DATE_EMPTY,
              where: startDates,
            }),
            ...this.handleMessage({
              type: 'date',
              message: this.constructor.FAIL_MESSAGE.END_DATE_EMPTY,
              where: endDates,
            }),
          ],
    );
  }

  testAll() {
    return Promise.all([
      this.testCompany(),
      this.testMetric(),
      this.testCells(),
      this.testDate(),
      this.testFyYears(),
      this.testDateEmpty(),
    ]);
    // return new Promise((resolve) => {
    //   return resolve(['Success']);
    // });
  }
}
